import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { useI18n } from "../i18n/i18n";
import { articles } from "../data/articles";

export default function BlogPreview() {
  const { lang, t } = useI18n();
  const top = articles.slice(0, 3);

  const fmt = (d) =>
    new Date(d).toLocaleDateString(lang === "de" ? "de-DE" : "en-GB", {
      year: "numeric",
      month: "short",
      day: "2-digit",
    });

  return (
    <section
      id="blog"
      data-testid="blog-preview-section"
      className="relative py-24 md:py-32 border-t border-white/5"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10 lg:px-14">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-12">
          <div className="max-w-xl">
            <p className="cs-overline mb-4">{t("blog.overline")}</p>
            <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl text-white leading-tight">
              {t("blog.title")}
            </h2>
            <p className="text-slate-400 mt-4">{t("blog.subtitle")}</p>
          </div>
          <Link
            to="/blog"
            className="cs-btn-secondary text-sm self-start md:self-auto"
            data-testid="blog-preview-all-button"
          >
            {t("blog.all_articles")}
            <ArrowUpRight className="w-4 h-4" />
          </Link>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {top.map((a, i) => (
            <Link
              key={a.slug}
              to={`/blog/${a.slug}`}
              data-testid={`blog-preview-card-${i}`}
              className="cs-card group overflow-hidden flex flex-col"
            >
              <div className="aspect-[16/10] overflow-hidden">
                <img
                  src={a.cover}
                  alt=""
                  className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
                />
              </div>
              <div className="p-6 flex flex-col gap-3">
                <div className="flex items-center gap-3 text-xs text-slate-400">
                  <span className="text-sky-400 font-semibold uppercase tracking-[0.18em] text-[10px]">
                    {a.tag[lang]}
                  </span>
                  <span>·</span>
                  <span>{fmt(a.date)}</span>
                  <span>·</span>
                  <span>{a.readingTime} {t("blog.reading_time")}</span>
                </div>
                <h3 className="font-display text-lg text-white leading-snug group-hover:text-sky-300 transition-colors">
                  {a.title[lang]}
                </h3>
                <p className="text-sm text-slate-400 line-clamp-3">{a.excerpt[lang]}</p>
                <span className="text-sm text-sky-400 mt-2 inline-flex items-center gap-1">
                  {t("blog.read_more")} <ArrowUpRight className="w-4 h-4" />
                </span>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}
